import { IAttributes } from 'angular'
import { ApiRegister } from '@vend/types'
import { STATES } from '../../../../../lib/routes'
import { CashMovementsManager } from '../../../managers/cash-movements-manager'
import { RegisterClosureManager } from '../../../managers/register-closure-manager'
import { $state } from '../../../ng-compat/imports'
import { WebRegisterManager } from '../../../managers/web-register-manager'

/**
 * Controller for the Open register panel component.
 *
 * @class OpenRegisterPanelController
 */
export class OpenRegisterPanelController {
  public openingRegister?: boolean
  public register?: ApiRegister

  constructor(
    private $attrs: IAttributes,
    private elementService: $TSFixMe,
    private registerClosureManager: RegisterClosureManager,
    public cashMovementsManager: CashMovementsManager,
    public webRegisterManager: WebRegisterManager
  ) {
    'ngInject'
  }

  /**
   * Open the register in scope.
   *
   * @method openRegister
   *
   * @param  {Object} cashFloatSettings
   *         The cash movement object for the opening cash float.
   *
   * @return {Promise} A promise resolved once the register in scope has been opened
   */
  public openRegister(cashFloatSettings: any) {
    this.openingRegister = true
    this.registerClosureManager
      .openRegister(this.register!, cashFloatSettings)
      .then(() => $state.go(STATES.SALE))
      .catch(() => {
        this.openingRegister = false
      })
  }

  public $postLink() {
    const panelClasses = ['open-register-panel-container']
    const modifiers = this.elementService.getComponentAttrs(
      this.$attrs,
      'modifier'
    )

    if (modifiers) {
      modifiers.forEach((modifier: $TSFixMe) =>
        panelClasses.push(`open-register-panel-container--${modifier}`)
      )
    }
    this.$attrs.$addClass(panelClasses as $TSFixMe)
  }

  public hasOpenClosePermission() {
    return this.registerClosureManager.hasOpenClosePermission()
  }
}
